import { RectIcon } from '@/components/IconButton';
import { useViewer } from '@/stores/viewer';
import { cn } from '@skand/ui';
import { useCallback } from 'react';

export const DrawDropdownIcon = () => {
  const enabledDraw2D = useViewer(state => state.enabledDraw2D);

  const Icon = useCallback(() => {
    switch (enabledDraw2D) {
      case 'rect':
        return <RectIcon />;
      case 'free':
      default:
        return <div className="i-skand-annotation h-4 w-4" />;
    }
  }, [enabledDraw2D]);

  return (
    <div className={cn('h-full', 'w-full', 'flex', 'flex-row', 'items-center', 'justify-around')}>
      <Icon />
      <div className="i-skand-dropdown h-6px w-6px" />
    </div>
  );
};
